import React from "react";

interface MessageCardProps {
  issueType: string;
  lastMessage: string;
  timeAgo: string;
  unread?: boolean;
  onClick?: () => void;
}

const MessageCard: React.FC<MessageCardProps> = ({
  issueType,
  lastMessage,
  timeAgo,
  unread,
  onClick,
}) => {
  return (
    <div
      className="flex w-full items-start justify-between py-3 cursor-pointer hover:bg-gray-50 rounded-lg px-2 transition-colors"
      onClick={onClick}
    >
      <div className="flex gap-3">
        <div className="relative flex-shrink-0">
          <div className="w-[60px] h-[60px] rounded-full border-2 border-[#E6439A] p-1">
            <div className="w-full h-full rounded-full flex items-center justify-center bg-[#B07793]">
              <span className="dcalligraphy text-[15px] text-white h-full w-full flex items-center justify-center">
                W
              </span>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col gap-1">
          <p className="text-[14px] text-gray-600 font-medium glacial">
            {issueType}
          </p>
          <p
            className={`text-[16px] leading-relaxed glacial line-clamp-2 ${
              unread ? "text-black font-semibold" : "text-black font-normal"
            }`}
          >
            {lastMessage}
          </p>
        </div>
      </div>

      {/* Timestamp + unread dot */}
      <div className="flex flex-col items-end gap-1">
        <span className="text-[14px] text-gray-400">{timeAgo}</span>
        {unread && (
          <span className="w-[10px] h-[10px] rounded-full bg-[#E6439A]" />
        )}
      </div>
    </div>
  );
};

export default MessageCard;